import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";

const sideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.dashboard.path,
        title: routeConstant.dashboard.title,
        Icon: Icons.DashboardHome,
      },
      {
        path: routeConstant.organizations.path,
        title: routeConstant.organizations.title,
        Icon: Icons.DashboardOrganization,
      },
      {
        path: routeConstant.requestedEvaluation.path,
        title: routeConstant.requestedEvaluation.title,
        Icon: Icons.DashboardPendingEvaluations,
      },
      {
        path: routeConstant.modifyQuestionnaire.path,
        title: routeConstant.modifyQuestionnaire.title,
        Icon: Icons.DashboardModifyQuestionnaire,
      },
    ],
  },
  {
    title: "Help",
    paths: [
      {
        path: routeConstant.contact.path,
        title: routeConstant.contact.title,
        Icon: Icons.DashboardCustomerSupport,
      },
      {
        path: routeConstant.document.path,
        title: routeConstant.document.title,
        Icon: Icons.Document,
      },
    ],
  },
];

const ColumnHeads: CustomTableHeadType[] = [
  {
    title: "Status",
    key: "isActive",
  },
  {
    title: "Job Title",
    key: "jobTitle",
  },
  {
    title: "Department",
    key: "department",
  },
  {
    title: "Job Code",
    key: "jobeCode",
  },
  {
    title: "Job Grade",
    key: "jobGrade",
  },
  {
    title: "Role Type",
    key: "roleType",
  },
  {
    title: "Level of Work & Modifier",
    key: "level_of_work.short_des",
  },
  {
    title: "Institutional Expertise & Skill",
    key: "q2.short_des",
  },
  {
    title: "Cultural Impact",
    key: "q3.short_des",
  },
  {
    title: "Physical Environment",
    key: "q4.short_des",
  },
  {
    title: "Mental & Emotional Environment",
    key: "q5.short_des",
  },
  {
    title: "Application of Knowledge & Skill",
    key: "q6.short_des",
  },
  {
    title: "Manual Effort",
    key: "q7.short_des",
  },
  {
    title: "Outcomes",
    key: "q8.short_des",
  },
  {
    title: "RAS Score",
    key: "rasScore",
  },
  {
    title: "RAS Level",
    key: "rasLevel",
  },
  {
    title: "RAS Code",
    key: "shortCode",
  },
  {
    title: "Evaluated By",
    key: "evaluated_by.name",
  },
  {
    title: "Last Date Modified",
    key: "created_at",
  },
  {
    title: "Action",
    key: "shortCode",
  },
];

const FixedColumns = [
  "Active",
  "Job Title",
  "RAS Score",
  "RAS Level",
  "RAS Code",
  "Evaluated By",
  "Last Date Modified",
  "Action",
];

const barChartOptions: any = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
      display: false,
    },
    title: {
      display: false,
      text: "",
    },

    tooltip: {
      displayColors: false,
      backgroundColor: "#FFBE1D",
      padding: 14,
      bodyFont: {
        padding: 20,
        size: 15,
        weight: "bold",
      },
      callbacks: {
        title: () => {
          return "";
        },
        labelTextColor: (context: any) => {
          return "#1A1919";
        },
        label: (context: any) => {
          return context.formattedValue + " Evaluations";
        },
        footer: (context: any) => {
          return "";
        },
      },
    },
  },
  scales: {
    x: {
      ticks: {
        display: true,
      },
      grid: {
        display: false,
      },
    },
    y: {
      ticks: {
        display: true,
      },
      grid: {
        display: true,
        color: "#3D3C3A",
      },
    },
  },
};

const GraphLabels: string[] = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export {
  sideBarConstants,
  ColumnHeads,
  FixedColumns,
  barChartOptions,
  GraphLabels,
};
